import React from 'react';
import EditOrAddGroupContactModalContainer from 'containers/Modals/EditOrAddGroupContactModalContainer';

export const AddGroupContactModal: React.FunctionComponent = () => 
    <EditOrAddGroupContactModalContainer isEditingExisting={false} />;
